module.exports = __webpack_public_path__ + "assets/b3b67b2ca2adb0ce68454001f962da66.png";